module.exports = __webpack_public_path__ + "static/img/icon-insurance-04.5f028a60.png";